import { API_URL } from "config";
import Http from "util/https";
import { CSVUploadOrderParam, CsvUploadPlaceOrderResponseApi, PlaceOrder } from "../types/index";
import { convertUTCToDate } from "../utils/common";

// const res: {data: CsvUploadPlaceOrderResponseApi} = {
//   data: {
//     process_id: "process_id1",
//     total: 15,
//     errors: ["error1"],
//     list: [{
//       client_cd: "000001",
//       item_cd: "000001",
//       jan_cd: "0123456789012",
//       vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ",
//       brand: "WH",
//       item_name: "WH STA",
//       size: "185/65R15H",
//       maker_item_cd: "-",
//       order_quantity: 1000,
//       unit_base_price: 10000,
//       unit_cost_price: 15000,
//       unit_sale_price: 20000,
//       desired_date: "2025-01-01",
//       author: "鈴木 太郎",
//       approver: "佐藤 花子",
//       shipping_scheduled: "2025-01-01",
//       shipping_dest_cd: "-",
//       shipping_dest_zip: "335-0038",
//       shipping_dest_address: "埼玉県戸田市美女木北２－１－１７",
//       shipping_dest_tel: "048-424-1111",
//       order_store_fax: "048-424-1112",
//       shipping_dest_name: "美女木店",
//       client_doc_no: "-",
//       is_customer_order: true,
//       memo: "店舗メモです",
//       remarks: "本部メモです"
//     }]
//   }
// }

/**
 * 発注CSV確認Api
 * @param params 発注Apiのパラメータ
 * @returns CSVCountCheckStock[]
 */
export default async function getCsvPlaceOrderConfirmApi(params: CSVUploadOrderParam) {
  console.log("params:", {...params, upload_kind: 0});
  const http = Http.default.alterAuth({useToken: true, useFormData: true});
  const url = `${API_URL}/order/product/csv/upload`;
  const res = await http.post<CsvUploadPlaceOrderResponseApi>(url, Http.convertObjectToFormData({...params, upload_kind: 0}));

  const orders: PlaceOrder[] = res.data.order_infos.map((s, i) => {
    const order: PlaceOrder = {
      id: i+1,
      clientCd: s.client_cd ?? '',
      storeCd: s.store_cd ?? '',
      productCd: s.item_cd ?? '',
      janCd: s.jan_cd ?? '',
      supplierName: s.supplier_name ?? '',
      brand: s.brand ?? '',
      productName: s.item_name ?? '',
      size: s.size ?? '',
      productNumber: s.maker_item_cd ?? '',
      orderCount: s.order_quantity || 0,
      headquartersCost: (s.order_quantity * s.unit_base_price) || 0,
      headquartersUnitCost: s.unit_base_price || 0,
      wholesalePrice: (s.order_quantity * s.unit_cost_price) || 0,
      wholesaleUnitPrice: s.unit_cost_price || 0,
      shopPrice: (s.order_quantity * s.unit_sale_price) || 0,
      shopUnitPrice: s.unit_sale_price || 0,
      requestDeliveryDate: convertUTCToDate(s.desired_date),
      shopOrderer: s.author ?? '',
      approver: s.approver ?? '',
      postalCd: s.shipping_dest_zip ?? '',
      destinationAddress: s.shipping_dest_address ?? '',
      destinationName: s.shipping_dest_name ?? '',
      phoneNumber: s.shipping_dest_tel ?? '',
      faxNumber: s.order_store_fax ?? '',
      destinationCd: s.shipping_dest_code ?? '',
      clientBillNumber: s.client_doc_no ?? '',
      isDirectDelivery: s.direct_shipping_flag != null ? Boolean(Number(s.direct_shipping_flag)) : undefined,
      isCustomerOrder: Boolean(Number(s.is_customer_order)) ?? false,
      shopRemarks: s.memo ?? '',
      headquartersRemarks: s.remarks ?? '',
      error: (s.errors && s.errors.length > 0) ? s.errors.join('\n') : undefined,
    };

    return order;
  });

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)})
  console.log(res);
  console.log(orders);
  return {
    orders,
    processId: res.data.process_id,
    total: res.data.total,
    // error: res.data.errors && res.data.errors.length > 0 ? 'エラーがあります。修正してからもう一度アップロードしてください。' : undefined,
    error: (res.data.errors && res.data.errors.length > 0) ? res.data.errors.join('\n').slice(0,100) : undefined,
  };
}
